<template>
  <div>
    <div class="btnsBox" v-if="config.buttons && config.buttons.length">
      <el-button
        v-for="(btn, name) in hasBtn(config.buttons)"
        :key="name"
        :type="btn.type"
        :style="`color:${btn.color}`"
        @click="handleBtn('tableBtn', { btn, checkList })"
        :disabled="btn.disabled ? checkList.length == 0 : false"
        >{{ btn.name }}</el-button
      >
    </div>
    <!-- 列表 -->
    <el-table
      ref="tableTem"
      :cell-class-name="checkbox"
      :data="config.data"
      :height="config.height"
      :border="config.border"
      :span-method="spanMethod"
      :highlight-current-row="config.highlightCurrentRow"
      :row-class-name="rowClassNameMethod"
      style="width: 100%"
      :row-key="config.rowKeyId?config.rowKeyId:'id'"
      @selection-change="handleBtn('handleSelectionChange', $event)"
      @sort-change="handleBtn('sortChange', $event)"
    >
      <template v-if="config.noDataText">
        <template slot="empty">
          <div>{{ config.noDataText }}</div>
        </template>
      </template>
      <template v-for="(item, index) in config.head">
        <!-- 多选 -->
        <el-table-column
          v-if="item.type === 'selection'"
          :key="index"
          type="selection"
          :width="item.width"
          :reserve-selection="true"
          :selectable="selectable(item)"
          :fixed="item.fixed ? item.fixed : false"
        >
        </el-table-column>
        <el-table-column
          v-else
          :key="index"
          :label="item.title"
          :type="item.type"
          :width="item.width"
          :prop="item.key"
          :align="item.align?item.align:'left'"
          :show-overflow-tooltip="item.showTool"
          :fixed="item.fixed ? item.fixed : false"
          :sortable="item.sortable"
        >
          <template slot-scope="scope">
            <!-- 插槽 -->
            <slot
              v-if="item.type === 'slot'"
              :name="item.slotName"
              :data="scope.row"
            ></slot>
            <!-- 序号 -->
            <span v-else-if="item.type === 'index'">
              {{
                config.currentPage
                  ? (config.currentPage - 1) * config.pageSize +
                    scope.$index +
                    1
                  : scope.$index + 1
              }}
            </span>
            <!-- 拥有链接 -->
            <span v-else-if="item.urlKey">
              <el-link
                type="primary"
                :href="scope.row[item.urlKey]"
                target="_blank"
                >{{ tableProperties(scope.row, item) }}</el-link
              >
            </span>
            <!-- 普通内容 -->
            <span
              v-else-if="item.key"
              :style="`color:${colorJudge(item, scope.row)}`"
            >
              {{ tableProperties(scope.row, item) }}
            </span>
            <!-- 按钮 -->
            <span v-else-if="item.btns">
              <template v-for="(btn, name) in hasBtn(item.btns)">
                <el-button
                  v-if="btnShow(btn, scope.row)"
                  :key="name"
                  :type="btn.type"
                  :style="`color:${btn.color}`"
                  @click="
                    handleBtn('tableBtn', {
                      btn,
                      row: scope.row,
                      index: scope.$index
                    })
                  "
                  >{{ btn.name }}</el-button
                >
                <span :key="name" v-else-if="btn.hiddenReplace">{{
                  btn.hiddenReplace
                }}</span>
              </template>
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-if="!config.hiddenPagination"
      :total="config.total"
      :currentPage="config.currentPage"
      :pageSize="config.pageSize"
      :easy="config.easy"
      @changePage="handleBtn('changePage', $event)"
      @changePages="handleBtn('changePages', $event)"
    >
    </pagination>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { parseTime } from "@/utils";
export default {
  name: "TableTem",
  components: { Pagination },
  data() {
    return {
      checkList: []
    };
  },

  props: {
    config: {
      type: Object,
      default: () => {
        return {
          head: [
            {
              title: "暂无表头"
            }
          ],
          data: [],
          total: 0,
          currentPage: 1,
          pageSize: 10
        };
      }
    },
    spanMethod: {
      default: null
    },
    conditionProp: {
      type: String,
      required: false
    },
    conditionValue: {
      type: [Boolean, String, Number],
      required: false
    },
  },

  computed: {
    // 返回有权限的按钮
    hasBtn() {
      return btns => {
        if (this.$route.meta && this.$route.meta.btns) {
          // 存在按钮权限则返回有权限的按钮
          return btns.filter(
            item => item.through || this.$route.meta.btns.includes(item.flag)
          );
        } else {
          // 不存在则返回所有按钮
          return btns;
        }
      };
    },
    // 显示值
    tableProperties() {
      return (row, item) => {
        let str = row[item.key];
        if (str === null || str === "") return "";
        // 标识对应显示值
        if (
          item.codeMateVal &&
          Object.prototype.toString.call(item.codeMateVal) === "[object Object]"
        ) {
          if (
            item.codeMateVal[str] &&
            Object.prototype.toString.call(item.codeMateVal[str]) !==
              "[object Object]"
          ) {
            // 旧版本的{值:显示值}
            str = item.codeMateVal[str];
          } else {
            // 新版本的可根据特定key判断
            for (let key in item.codeMateVal) {
              if (
                row[key] !== undefined &&
                row[key] !== null &&
                item.codeMateVal[key][row[key]]
              ) {
                str = item.codeMateVal[key][row[key]];
              }
            }
          }
        }
        // 时间格式
        if (item.format) {
          str = parseTime(str, item.format);
        }
        // 单位
        if (item.unit) {
          str = str + item.unit;
        }
        return str;
      };
    },
    // 时间格式
    parseTime() {
      return (val, format) => parseTime(val, format);
    },
    // 返回颜色
    colorJudge() {
      return (row, val) => {
        if (
          row.colorJudge &&
          Object.prototype.toString.call(row.colorJudge) === "[object Object]"
        ) {
          if (
            row.colorJudge[val[row.key]] &&
            Object.prototype.toString.call(row.colorJudge[val[row.key]]) !==
              "[object Object]"
          ) {
            // 旧版本的{值:颜色}
            return row.colorJudge[val[row.key]];
          } else {
            // 新版本的可根据特定key判断
            for (let key in row.colorJudge) {
              if (
                val[key] !== undefined &&
                val[key] !== null &&
                row.colorJudge[key][val[key]]
              ) {
                return row.colorJudge[key][val[key]];
              }
            }
          }
        }
      };
    },
    // 按钮显示隐藏
    btnShow() {
      return (btn, row) => {
        if (btn.hidden && btn.show) {
          console.warn(
            "tableTem-head-btns 中hidden与show同时存在,请检查是否为误操作!!"
          );
        }
        // #region --- 隐藏
        if (
          btn.hidden &&
          Object.prototype.toString.call(btn.hidden) === "[object Array]"
        ) {
          let flagArr = btn.hidden.slice(1, btn.hidden.length);
          return !flagArr.some(item => {
            return row[btn.hidden[0]] === item;
          });
        } else if (
          btn.hidden &&
          Object.prototype.toString.call(btn.hidden) === "[object Object]"
        ) {
          let falg = true;
          for (const key in btn.hidden) {
            if (falg) {
              falg = !btn.hidden[key].some(item => {
                return row[key] === item;
              });
            }
          }
          return falg;
        }
        // #endregion

        // #region --- 显示
        if (
          btn.show &&
          Object.prototype.toString.call(btn.show) === "[object Array]"
        ) {
          let flagArr = btn.show.slice(1, btn.show.length);
          return flagArr.some(item => {
            return row[btn.show[0]] === item;
          });
        } else if (
          btn.show &&
          Object.prototype.toString.call(btn.show) === "[object Object]"
        ) {
          let falg = false;
          for (const key in btn.show) {
            if (!falg) {
              falg = btn.show[key].some(item => {
                return row[key] === item;
              });
            }
          }
          return falg;
        }
        // #endregion

        return true;
      };
    },
    // 获取select隐藏条件
    getSelectHidden() {
      // #region --- 旧版本循环得到selectHidden
      // let selectHidden = [];
      // this.config.head.some(item => {
      //   // 循环得到隐藏的条件
      //   if (item.type === "selection" && item.selectHidden?.length > 0) {
      //     selectHidden = item.selectHidden;
      //     return true;
      //   }
      // });
      // #endregion
      let selectHidden = []
      let c_selectHidden = this.config.head_obj?.selection_u?.selectHidden
      if( c_selectHidden && Object.prototype.toString.call(c_selectHidden) === "[object Array]"){
        selectHidden = c_selectHidden
      }
      return selectHidden;
    }
  },

  created() {
    this.formattingConfig();
  },

  beforeMount() {},

  mounted() {
    if (this.config.selectName) {
      // 表头全选显示值
      this.$nextTick(() => {
        document.getElementsByClassName(
          "el-checkbox"
        )[0].parentNode.innerHTML = this.config.selectName;
      });
    }
  },

  methods: {
    // config处理
    formattingConfig() {
      this.config.head_obj = {};
      this.config.head.forEach((item, index) => {
        if (item.key) {
          this.config.head_obj.IDX = index;
          this.config.head_obj[item.key] = item;
        } else if (item.type) {
          this.config.head_obj[`${item.type}_u`] = item;
        }
      });
      // console.log(this.config.head_obj);
    },
    // #region --- 表单控制
    // 表格选择框是否可选 true-可选 false-禁选
    selectable(config) {
      return (row, index) => {
        if (config.selectable?.length > 0)
          return !config.selectable.some(item =>
            item.slice(1).some(it => row[item[0]] == it)
          );
        return true;
      };
    },
    // 表单选择框的隐藏
    checkbox(row) {
      let selectHidden = this.getSelectHidden;
      if (selectHidden.length > 0) {
        // 根据条件添加隐藏的样式
        let flag = selectHidden.some(item =>
          item.slice(1).some(it => row.row[item[0]] === it)
        );
        if (flag) {
          return "mycell";
        }
      }
    },
    // #endregion
    // #region --- 按钮
    // 按钮入口
    handleBtn(name, data) {
      let fn = this[name](name);
      fn && fn(data);
    },
    // 列表按钮
    tableBtn(name) {
      return data => {
        this.$emit("tableBtn", data);
      };
    },
    //排序按钮
    sortChange(name) {
      return data => {
        this.$emit("sortChange", data);
      };
    },
    rowClassNameMethod({ row }) {
      if (typeof this.config.rowClassNameMethod === 'function') {
        return this.config.rowClassNameMethod(row)
      }
      if (row[this.conditionProp] === this.conditionValue) {
        return this.config.className;
      }
      return '';
    },
    // 复选
    handleSelectionChange(name) {
      return data => {
        this.checkList = data;
        let selectHidden = this.getSelectHidden;
        if (selectHidden.length > 0) {
          this.checkList = this.checkList.filter(item => {
            let flag = selectHidden.some(it =>
              it.slice(1).some(t => item[it[0]] === t)
            );
            return !flag;
          });
        }
        if(!this.checkList.length){
          this.$refs.tableTem.clearSelection()
        }

      };
    },
    // 分页按钮
    changePage(name) {
      return data => {
        this.$emit("changePage", data);
      };
    },
    changePages(name) {
      return data => {
        this.$emit("changePages", data);
      };
    }
    // #endregion
  }
};
</script>

<style scoped lang="scss">
::v-deep.el-table .mycell .el-checkbox {
  display: none;
}
.el-table{
  ::v-deep .is-repeat{
    background-color: #fce1bd;
    &.hover-row{
      background-color: #f0cfa1;
      >td{
        background-color: #fce1bd !important;
        transition: none;
      }
    }
  }
}
</style>
